import { Conteiner, Actions, Filter } from './styled';
import { IoIosSearch } from 'react-icons/io';
import { BiFilter } from 'react-icons/bi';
import { RiFileExcel2Fill } from 'react-icons/ri';


export const Table = (props) => {

  const { id, data, keyLine, column, onFilter, search, setSearch, onGeneratorExcel } = props;

  return (

    <Conteiner>
      <Actions>
        <Filter>
          <span>
            <IoIosSearch />
          </span>
          <input type='text' value={search} onChange={(e) => setSearch(e.target.value)} />
          <button onClick={onFilter} >
            <BiFilter />
            Filtrar
          </button>
        </Filter>
        <RiFileExcel2Fill className='generatorExcel' onClick={onGeneratorExcel} />
      </Actions>
      <table cellSpacing="0" cellPadding="0" id={id}>
        <thead cellSpacing="0" cellPadding="0">
          <tr>
            {column?.length > 0 &&
              column?.map((item) => {
                return (
                  <th key={`${item?.key}%20${item?.title}`}>
                    {item?.title}
                  </th>
                )
              })
            }
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 &&
            data?.map((item) => {
              return (
                <tr key={item[keyLine]}>
                  {column?.length > 0 &&
                    column?.map((columnItem) => {
                      return (
                        <th key={columnItem?.key}>
                          {columnItem.component(item)}
                        </th>
                      )
                    })
                  }
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </Conteiner>
  );
};